(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const mobileQuery = window.matchMedia('(max-width: 991px)');

  function fetchProductCards(url) {
    return fetch(url)
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => Array.from(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.snippet-product-grid')))
      .catch((e) => {
        console.error(e);
        return [];
      });
  }

  function initQuickAdd() {
    if (typeof quickAddButton == 'function') quickAddButton();
  }

  // Moves the given slides into swiper markup inside container and adds the theme's arrows
  function buildSlider(container, slides) {
    const swiperEl = document.createElement('div');
    const wrapper = document.createElement('div');
    swiperEl.className = 'swiper';
    wrapper.className = 'swiper-wrapper';
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
      wrapper.appendChild(slide);
    });
    swiperEl.appendChild(wrapper);
    container.innerHTML = '';
    container.appendChild(swiperEl);
    const arrows = document.getElementById('article-main-slider-arrows');
    if (arrows) container.appendChild(arrows.content.cloneNode(true));
    return swiperEl;
  }

  function createSwiper(container, swiperEl, spaceBetween) {
    return new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,
      watchOverflow: true,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
    });
  }

  // <div class="bb-products" data-products="handle-1,handle-2"></div>
  // <div class="bb-products" data-collection="handle" data-limit="8"></div>
  function loadProducts(container) {
    const handles = (container.dataset.products || '').split(',').map((handle) => handle.trim()).filter(Boolean);
    const limit = parseInt(container.dataset.limit, 10) || 10;
    let request;
    if (handles.length) {
      request = Promise.all(handles.map((handle) => fetchProductCards(`${root}products/${encodeURIComponent(handle)}?view=blog-product`))).then((cards) => cards.flat());
    } else if (container.dataset.collection) {
      request = fetchProductCards(`${root}collections/${encodeURIComponent(container.dataset.collection.trim())}?view=blog-collection`);
    } else {
      request = Promise.resolve([]);
    }
    request.then((cards) => {
      if (!cards.length) {
        container.remove();
        return;
      }
      const slides = cards.slice(0, limit).map((card) => {
        const slide = document.createElement('div');
        slide.appendChild(card);
        return slide;
      });
      const swiperEl = buildSlider(container, slides);
      createSwiper(container, swiperEl, mobileQuery.matches ? 12 : 16);
      initQuickAdd();
    });
  }

  // Image pairs (.bb-images, .bb-links) are a static row on desktop and a slider on mobile
  function initMobileSlider(container) {
    const swiperEl = buildSlider(container, Array.from(container.children));
    let swiper = null;
    const toggle = () => {
      if (mobileQuery.matches && !swiper) {
        swiper = createSwiper(container, swiperEl, 16);
      } else if (!mobileQuery.matches && swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    };
    toggle();
    mobileQuery.addEventListener('change', toggle);
  }

  // Embeds used by articles written before the V2 layout
  function loadLegacyEmbeds() {
    document.querySelectorAll('.article-main .blog-product').forEach((container) => {
      fetch(`${root}products/${container.dataset.handle}?view=blog-product`)
        .then((response) => response.text())
        .then((html) => {
          const source = new DOMParser().parseFromString(html, 'text/html').getElementById('section-blog-product');
          if (!source) return;
          container.innerHTML = source.innerHTML;
          initQuickAdd();
        })
        .catch((e) => console.error(e));
    });
    document.querySelectorAll('.article-main .blog-collection').forEach((container) => {
      fetchProductCards(`${root}collections/${container.dataset.handle}?view=blog-collection`).then((cards) => {
        if (!cards.length) return;
        const slides = cards.map((card) => {
          const slide = document.createElement('div');
          slide.appendChild(card);
          return slide;
        });
        const swiperEl = buildSlider(container, slides);
        new Swiper(swiperEl, {
          slidesPerView: 3,
          spaceBetween: 8,
          navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            0: { slidesPerView: 1.2 },
            768: { slidesPerView: 3 },
          },
        });
        initQuickAdd();
      });
    });
  }

  document.querySelectorAll('.article-main .bb-products').forEach(loadProducts);
  document.querySelectorAll('.article-main .bb-images, .article-main .bb-links').forEach(initMobileSlider);
  loadLegacyEmbeds();
})();
